export default "__VITE_ASSET__BxNMIoXP__"